import { render, staticRenderFns } from "./gamedetail.vue?vue&type=template&id=b7842df4&scoped=true"
import script from "./gamedetail.vue?vue&type=script&lang=js"
export * from "./gamedetail.vue?vue&type=script&lang=js"
import style0 from "./gamedetail.vue?vue&type=style&index=0&id=b7842df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7842df4",
  null
  
)

export default component.exports